import { Box, Typography } from '@mui/material'

export const ThemesBlock = ({ themes }) => (
  <Box>
    <Typography variant="h5">Themes</Typography>
    <Box sx={{ marginTop: '16px', display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {themes?.map((theme) => (
        <Typography
          variant="body2"
          color="text.tertiary"
          key={theme.id}
          sx={(theme) => ({
            borderRadius: '20px',
            border: '2px solid #FFFFFF1A',
            padding: theme.spacing(0, 2),
          })}
        >
          {theme.name}
        </Typography>
      ))}
    </Box>
  </Box>
)
